import styled from 'styled-components';
import { ContainerSection } from '../styles';

export const Container = styled(ContainerSection)``;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1rem;
`;

export const TitleSection = styled.h4`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
`;

